module.exports = __webpack_public_path__ + "img/陳俊佑.98f9a82b.jpg";